export default function translate(i18n, propriete) {
  if (propriete === 'libelle') return i18n.t('addEditTourneeModele.errors.libelle');
  if (propriete === 'jourDepart') return i18n.t('addEditTourneeModele.errors.jourDepart');
  if (propriete.includes('Ordre')) return i18n.t('addEditTourneeModele.errors.ordre');
  if (propriete === 'afficheurId') return i18n.t('addEditTourneeModele.errors.afficheur');
  return propriete;
}
